export { readPrismicField as getOptionalPrismicField } from './sliceCta';

/**
 * @deprecated Import CTA helpers from '@/utils/sliceCta' or '@/utils'.
 */
export type {
  CtaVariant,
  MappedSliceCta as MappedPrismicCta,
} from './sliceCta';
export { toCtaButtonProps } from './sliceCta';
